var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UpcomingInvoicesTreatmentList',{attrs:{"invoiceId":_vm.invoiceId},on:{"saveTreatmentDetail":_vm.saveTreatmentDetail,"saveUpdatedTreatmentDetails":_vm.saveUpdatedTreatmentDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }